import React from "react";
import '../../styles/Careers.css';
import MetaChip from "../sharedComponents/MetaChip";

const jobs = [
  { title: "Internship Programme – India" },
  { title: "Internship Programme – International" },
  { title: "Associate Expert – India" },
  { title: "Associate Expert – International" },
  { title: "Associate Partners Programme – Asia" },
  { title: "Associate Partners Programme – International" },
  { title: "International Tenders and Grants" }
];

const JobList = () => {
  return (
    <div className="job-page">
      <div className="hero">
        <div className="hero-content">
          <div style={{ marginBottom: "20px" }}>
                       
            
          </div>
          <h1>We are Interested in...</h1>
          <p className="subtext">
            GreenWorks is committed to making transformation climate, economic and social system by engaging and exchaging in
          </p>
        </div>
      </div>

      <div className="job-grid">
        {jobs.map((job, i) => (
          <div key={i} className="job-card">
            <h3>{job.title}</h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default JobList;
